import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { FormInput, FormWrapper } from '../../Form/FormInput';
import { prop } from '../../../../utilities';
import { Select } from '../../General/Select';
import { TextP } from '../../../Defaults/Text';
import { DsiCheckBox } from '../../General/Checkbox';

interface Props {
  company: any;
  onChange: (e) => void;
  onBlur: (updatedData: any) => void;
  isVisible: boolean;
  problems: any;
  isB2B?: boolean;
  lang: string;
  onChangeBilling: any;
  formProblems: any;
  billingAddressState: any;
  handleBillingBlur: any;
  handleVatPayerChange: any;
  vat_payer: boolean;
}

function CompanyInfo({
  company,
  onChange,
  onBlur,
  isVisible,
  problems,
  isB2B,
  onChangeBilling,
  lang,
  billingAddressState,
  formProblems,
  handleBillingBlur,
  handleVatPayerChange,
  vat_payer,
}: Props) {
  const { companyName, ico, dic, ic_dph } = company;

  const handleBlur = () => {
    onBlur({ ...company, name: companyName });
  };

  if (!isVisible) {
    return <EmptyWrapper />;
  }

  const {
    nameProblem: companyNameProblem,
    icoProblem,
    dicProblem,
    icDphProblem,
  } = {
    nameProblem: prop(problems, 'name'),
    icoProblem: prop(problems, 'ico'),
    dicProblem: prop(problems, 'dic'),
    icDphProblem: prop(problems, 'ic_dph'),
  };

  const {
    nameProblem,
    surnameProblem,
    streetProblem,
    streetNrProblem,
    cityProblem,
    zipProblem,
  } = {
    nameProblem: prop(formProblems, 'billing_address.person.name'),
    surnameProblem: prop(formProblems, 'billing_address.person.surname'),
    streetProblem: prop(formProblems, 'billing_address.street'),
    streetNrProblem: prop(formProblems, 'billing_address.street_number'),
    cityProblem: prop(formProblems, 'billing_address.city'),
    zipProblem: prop(formProblems, 'billing_address.zip'),
  };

  const {
    name: name,
    surname: surname,
    street: street,
    street_number: streetNumber,
    city: city,
    zip: zip,
    country: country,
  } = billingAddressState;
  // const name =
  //   prop(billingAddressState, 'bname') || prop(billingAddressState, 'name');
  // const surname =
  //   prop(billingAddressState, 'bsurname') ||
  //   prop(billingAddressState, 'surname');
  // const street =
  //   prop(billingAddressState, 'bstreet') || prop(billingAddressState, 'street');
  // const street_number =
  //   prop(billingAddressState, 'bstreet_number') ||
  //   prop(billingAddressState, 'street_number');
  // const city =
  //   prop(billingAddressState, 'bcity') || prop(billingAddressState, 'city');
  // const zip =
  //   prop(billingAddressState, 'bzip') || prop(billingAddressState, 'zip');
  // const country =
  //   prop(billingAddressState, 'bcountry') ||
  //   prop(billingAddressState, 'country');

  return (
    <Wrapper isB2B={isB2B}>
      {!isB2B && <Text>{__('Fakturačné údaje')}</Text>}
      {/* <NameWrapper>
        <FormInput
          justText={isB2B}
          name={'bname'}
          type="text"
          label={__('Meno')}
          value={name}
          required={true}
          marginBottom={16}
          minWidthPx={288}
          marginRight={32}
          onChange={onChangeBilling}
          onBlur={handleBillingBlur}
          validMessage={nameProblem}
          validateAllowedChars={true}
        />
        <FormInput
          name={'bsurname'}
          type="text"
          required={true}
          label={__('Priezvisko')}
          minWidthPx={288}
          value={surname}
          marginBottom={16}
          onChange={onChangeBilling}
          onBlur={handleBillingBlur}
          validMessage={surnameProblem}
          validateAllowedChars={true}
        />
      </NameWrapper> */}
      <AddressWrapper isB2B={isB2B}>
        <FormWrapper isB2B={isB2B} noWrap={true} marginRight={32}>
          <FormInput
            justText={isB2B}
            name="bstreet"
            type="text"
            label={__('Ulica')}
            value={isB2B ? `${street} ${streetNumber}` : street}
            maxWidth={100}
            maxWidthPx={224}
            required={true}
            marginRight={16}
            onChange={onChangeBilling}
            onBlur={handleBillingBlur}
            validMessage={streetProblem}
            validateAllowedChars={true}
          />
          <FormInput
            name="bstreet_number"
            label={__('Číslo')}
            value={streetNumber}
            maxWidth={34}
            required={true}
            maxWidthPx={80}
            onChange={onChangeBilling}
            onBlur={handleBillingBlur}
            validMessage={streetNrProblem}
            validateAllowedChars={true}
          />
        </FormWrapper>
        <FormWrapper isB2B={isB2B} noWrap={true}>
          <FormInput
            justText={isB2B}
            name="bcity"
            type="text"
            label={__('Mesto')}
            value={city}
            maxWidth={100}
            maxWidthPx={224}
            marginRight={16}
            required={true}
            onChange={onChangeBilling}
            onBlur={handleBillingBlur}
            validMessage={cityProblem}
            validateAllowedChars={true}
          />
          <FormInput
            justText={isB2B}
            name="bzip"
            type="text"
            label={__('PSČ')}
            value={zip}
            maxWidth={34}
            maxWidthPx={80}
            required={true}
            onChange={onChangeBilling}
            onBlur={handleBillingBlur}
            validMessage={zipProblem}
            validateAllowedChars={true}
          />
        </FormWrapper>{' '}
      </AddressWrapper>
      <Select
        justText={isB2B}
        marginBottom={32}
        name="bcountry"
        label={__('Krajina')}
        value={country}
        required={true}
        options={
          lang === 'cz'
            ? [{ value: 'cz', name: __('Česká republika') }]
            : [{ value: 'sk', name: 'Slovensko' }]
        }
        // tslint:disable-next-line:jsx-no-lambda
        onChange={onChangeBilling}
        onBlur={handleBillingBlur}
      />
      <FormInput
        justText={isB2B}
        name={'companyName'}
        type="text"
        label={__('Firma')}
        value={companyName}
        required={true}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={companyNameProblem}
        validateAllowedChars={true}
      />
      <FormInput
        justText={isB2B}
        name={'ico'}
        type="text"
        required={true}
        label={__('IČO')}
        value={ico}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={icoProblem}
        validateAllowedChars={true}
      />
      <FormInput
        justText={isB2B}
        name={'dic'}
        type="text"
        required={true}
        label={__('DIČ')}
        value={dic}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={dicProblem}
        validateAllowedChars={true}
      />
      {lang === 'sk' && (
        <FormInput
          justText={isB2B}
          name={'ic_dph'}
          type="text"
          label={__('IČ DPH')}
          value={ic_dph}
          marginBottom={0}
          onChange={onChange}
          onBlur={handleBlur}
          validMessage={icDphProblem}
          validateAllowedChars={true}
        />
      )}
      {lang === 'cz' && (
        <DsiCheckBox
          name="vat_payer"
          onClick={handleVatPayerChange}
          selected={vat_payer}
          label={__('Platca DPH')}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ isB2B?: boolean }>`
  margin: ${rem(32)} 0;
  margin-bottom: ${({ isB2B }) => (isB2B ? 0 : rem(32))};
`;

const EmptyWrapper = styled.div`
  margin-bottom: ${rem(24)};
`;

const NameWrapper = styled(FlexRow)`
  flex-flow: row wrap;
`;

const AddressWrapper = styled(FlexRowCenterVertical)<{ isB2B?: boolean }>`
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row wrap')};
  align-items: ${({ isB2B }) => (isB2B ? 'flex-start' : 'center')};
`;

const Text = styled(TextP)`
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(38)};
  margin-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
  `}
`;

export { CompanyInfo };
